/* eslint-disable import/first */
if (process.env.NODE_ENV) {
  // Must be the first import
  import('preact/debug');
} else {
  // Or if you just want the devtools bridge (~240B) without other
  // debug code (useful for production sites)
  import('preact/devtools');
}

import './main.css';
import Layout from 'utils/layout';
import Video from 'utils/video';

import AddToCartForm from './utils/add-to-cart-form';
import SwiperCarousel from './utils/swiper-carousel';
import ProductCard from './utils/product-card/product-card';
import Accordion from './utils/accordion';
import './utils/input';

// let the browser know that <my-element> is served by our new class
customElements.define('atc-form', AddToCartForm);
customElements.define('product-card', ProductCard);
customElements.define('swiper-carousel', SwiperCarousel);
customElements.define('accordion-element', Accordion);

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
          module(element, { ...data, layout, videos });
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });
})();
